(() => {
  const announcement = document.querySelector('.v2-announcement');
  if (announcement) {
    const messages = [...announcement.querySelectorAll('[data-announcement]')];
    const toggle = announcement.querySelector('.v2-announcement-toggle');
    let current = 0, timer, visible = true;
    let paused = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const sync = () => {
      clearInterval(timer);
      toggle.setAttribute('aria-label', paused ? 'Play announcements' : 'Pause announcements');
      toggle.querySelector('path').setAttribute('d', paused ? 'm9 5 10 7-10 7Z' : 'M9 5v14M15 5v14');
      if (!paused && visible && !document.hidden) timer = setInterval(() => {
        messages[current].hidden = true;
        current = (current + 1) % messages.length;
        messages[current].hidden = false;
      }, 5000);
    };
    toggle.hidden = messages.length < 2;
    toggle.addEventListener('click', () => { paused = !paused; sync(); });
    document.addEventListener('visibilitychange', sync);
    new IntersectionObserver(([entry]) => { visible = entry.isIntersecting; sync(); }).observe(announcement);
    sync();
  }
  const form = document.querySelector('#v2-product-form');
  if (!form) return;
  const radios = [...form.querySelectorAll('input[name="id"]')];
  const submits = [...document.querySelectorAll('.v2-add, .v2-sticky button')];
  const message = form.querySelector('.v2-form-message');
  let busy = false;
  function syncPack() {
    const choice = radios.find(input => input.checked);
    if (!choice) return;
    document.querySelectorAll('[data-active-price]').forEach(el => { el.textContent = choice.dataset.price; });
    document.querySelectorAll('[data-active-pack]').forEach(el => { el.textContent = choice.dataset.name; });
    submits.forEach(button => { button.disabled = busy || choice.disabled; });
    document.querySelectorAll('[data-add-label]').forEach(el => { el.textContent = busy ? 'Adding…' : choice.disabled ? 'Unavailable' : 'Add to cart'; });
  }
  radios.forEach(input => input.addEventListener('change', syncPack));
  syncPack();
  form.addEventListener('submit', async event => {
    event.preventDefault();
    if (busy) return;
    const selected = radios.find(input => input.checked);
    if (!selected || selected.disabled) return;
    busy = true; syncPack();
    message.hidden = true;
    form.querySelector('.v2-cart-success').hidden = true;
    let drawerOpened = false;
    try {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(`${root}cart/add.js`, {method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'}, body:JSON.stringify({items:[{id:Number(selected.value),quantity:1}],sections:window.dpV2Cart ? [window.dpV2Cart.section] : [],sections_url:location.pathname})});
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || 'This pack could not be added. Please try again.');
      message.textContent = `${selected.dataset.name} added to your cart.`;
      if (window.dpV2Cart) drawerOpened = await window.dpV2Cart.open({sections:result.sections,trigger:event.submitter,added:true});
      form.querySelector('.v2-cart-success').hidden = drawerOpened;
    } catch (error) {
      message.textContent = error.message || 'We couldn’t connect to your cart. Please try again.';
    } finally {
      busy = false; syncPack(); message.hidden = drawerOpened;
      if (!drawerOpened) {
        message.focus({preventScroll:true});
        message.scrollIntoView({block:'center',behavior:'auto'});
      }
    }
  });
  const gallery = document.querySelector('.v2-gallery-track');
  const thumbs = [...document.querySelectorAll('[data-photo]')];
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const videos = [...document.querySelectorAll('video[data-autoplay]')];
  if (!reduced && !navigator.connection?.saveData) {
    const visibleVideos = new Set();
    const syncVideo = video => {
      if (visibleVideos.has(video) && !document.hidden) {
        video.muted = true;
        video.play().catch(() => {}); // Native controls remain available if autoplay is blocked.
      } else {
        video.pause();
      }
    };
    const observer = new IntersectionObserver(entries => {
      entries.forEach(({target, intersectionRatio}) => {
        if (intersectionRatio >= 0.4) visibleVideos.add(target);
        else visibleVideos.delete(target);
        syncVideo(target);
      });
    }, {threshold: [0, 0.4]});
    videos.forEach(video => observer.observe(video));
    document.addEventListener('visibilitychange', () => videos.forEach(syncVideo));
  }
  function showPhoto(index) {gallery.scrollTo({left:gallery.clientWidth * index,behavior:reduced ? 'auto':'smooth'});}
  // Touch gestures move at most one slide; native vertical page scrolling stays available.
  let drag;
  gallery.addEventListener('pointerdown', event => {
    if (!event.isPrimary || event.pointerType === 'mouse') return;
    drag = {id:event.pointerId,x:event.clientX,y:event.clientY,index:Math.round(gallery.scrollLeft / gallery.clientWidth),dx:0,horizontal:false};
  });
  gallery.addEventListener('pointermove', event => {
    if (!drag || event.pointerId !== drag.id) return;
    const dx = event.clientX - drag.x, dy = event.clientY - drag.y;
    if (!drag.horizontal) {
      if (Math.abs(dy) > 8 && Math.abs(dy) > Math.abs(dx)) { drag = null; return; }
      if (Math.abs(dx) < 8 || Math.abs(dx) < Math.abs(dy) * 1.2) return;
      drag.horizontal = true;
      gallery.setPointerCapture(event.pointerId);
      gallery.classList.add('is-dragging');
      gallery.scrollTo({left:drag.index * gallery.clientWidth,behavior:'instant'});
    }
    drag.dx = dx;
    gallery.scrollLeft = drag.index * gallery.clientWidth - Math.max(-gallery.clientWidth, Math.min(gallery.clientWidth,dx));
  });
  const endDrag = event => {
    if (!drag || event.pointerId !== drag.id) return;
    const gesture = drag; drag = null;
    if (!gesture.horizontal) return;
    const step = event.type !== 'pointercancel' && Math.abs(gesture.dx) >= 36 ? (gesture.dx < 0 ? 1 : -1) : 0;
    const next = Math.max(0,Math.min(thumbs.length-1,gesture.index+step));
    gallery.classList.remove('is-dragging');
    showPhoto(next);
  };
  gallery.addEventListener('pointerup', endDrag);
  gallery.addEventListener('pointercancel', endDrag);
  thumbs.forEach((button,index) => button.addEventListener('click', () => showPhoto(index)));
  gallery.addEventListener('scroll', () => {const index = Math.round(gallery.scrollLeft / gallery.clientWidth); thumbs.forEach((button,i) => button.setAttribute('aria-pressed',String(i === index)));}, {passive:true});
  gallery.addEventListener('keydown', event => {if (!['ArrowLeft','ArrowRight'].includes(event.key)) return; event.preventDefault();const index = Math.round(gallery.scrollLeft/gallery.clientWidth);showPhoto(Math.max(0,Math.min(thumbs.length-1,index+(event.key==='ArrowRight'?1:-1))));});
  const tabs = [...document.querySelectorAll('[data-benefit]')];
  function selectBenefit(index) {tabs.forEach((tab,i) => {tab.setAttribute('aria-selected',String(i===index));tab.tabIndex=i===index?0:-1;document.getElementById(`benefit-${i}`).hidden=i!==index;});}
  tabs.forEach((tab,index) => {tab.addEventListener('click',()=>selectBenefit(index));tab.addEventListener('keydown',event=>{if(!['ArrowLeft','ArrowRight','Home','End'].includes(event.key))return;event.preventDefault();const next=event.key==='Home'?0:event.key==='End'?tabs.length-1:(index+(event.key==='ArrowRight'?1:tabs.length-1))%tabs.length;selectBenefit(next);tabs[next].focus();});});
  const storyButtons = [...document.querySelectorAll('[data-story]')];
  const mini = document.querySelector('.v2-comments');
  if (mini) {
    const slides = [...mini.querySelectorAll('[data-mini-slide]')];
    const photos = [...mini.querySelectorAll('[data-mini-photo]')];
    let index = 0;
    const show = next => {
      index = (next + slides.length) % slides.length;
      slides.forEach((slide,i) => { slide.hidden = i !== index; });
      photos.forEach((photo,i) => photo.setAttribute('aria-pressed', String(i === index)));
      mini.querySelector('[data-mini-count]').textContent = `${index + 1} / ${slides.length}`;
    };
    mini.querySelector('[data-mini-prev]').addEventListener('click', () => show(index - 1));
    photos.forEach((photo,i) => photo.addEventListener('click', () => show(i)));
    mini.querySelector('[data-mini-next]').addEventListener('click', () => show(index + 1));
    let start;
    mini.addEventListener('touchstart', e => { start = {x:e.touches[0].clientX,y:e.touches[0].clientY}; }, {passive:true});
    mini.addEventListener('touchend', e => {
      if (!start) return;
      const dx = e.changedTouches[0].clientX - start.x, dy = e.changedTouches[0].clientY - start.y;
      if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) * 1.5) show(index + (dx < 0 ? 1 : -1));
      start = null;
    }, {passive:true});
  }
  let storyIndex = 0;
  function showStory(index) {
    storyIndex = (index + storyButtons.length) % storyButtons.length;
    storyButtons.forEach((button,i) => {button.setAttribute('aria-pressed',String(i===storyIndex));document.getElementById(`v2-story-${i}`).hidden=i!==storyIndex;});
    document.querySelector('[data-story-count]').textContent = `${storyIndex+1} / ${storyButtons.length}`;
  }
  storyButtons.forEach((button,index) => button.addEventListener('click',()=>showStory(index)));
  document.querySelector('[data-story-prev]').addEventListener('click',()=>showStory(storyIndex-1));
  document.querySelector('[data-story-next]').addEventListener('click',()=>showStory(storyIndex+1));
  const story = document.querySelector('.v2-story-review');
  let touchStart;
  story.addEventListener('touchstart',event=>{touchStart={x:event.touches[0].clientX,y:event.touches[0].clientY};},{passive:true});
  story.addEventListener('touchend',event=>{if(!touchStart)return;const dx=event.changedTouches[0].clientX-touchStart.x,dy=event.changedTouches[0].clientY-touchStart.y;if(Math.abs(dx)>50&&Math.abs(dx)>Math.abs(dy)*1.5)showStory(storyIndex+(dx<0?1:-1));touchStart=null;},{passive:true});
})();
